export const CONTRACTIONS_ROOT_LINK_ID = "contractions";

export const CONTRACTIONS_DATE_TIME_LINK_ID = "contractionsDateTime";
export const CONTRACTIONS_DATE_LINK_ID = "contractionsDate";
export const CONTRACTIONS_TIME_LINK_ID = "contractionsTime";

export const CONTRACTIONS_FREQUENCY_LINK_ID = "contractionsFrequency";
export const CONTRACTIONS_DURATION_LINK_ID = "contractionsDuration";
export const CONTRACTION_STRENGTH_LINK_ID = "contractionStrength";
export const CONTRACTIONS_COPING_LINK_ID = "contractionsCoping";
export const CONTRACTIONS_NOTES_LINK_ID = "contractionsNotes";
export const CONTRACTIONS_SIGNATURE_INITIALS_LINK_ID = "contractionsSignatureInitials";

export const CONTRACTIONS_QUESTIONNAIRE_NAME = "contractions";
